import { useContext } from "react"

import { Button } from "reactstrap"

import { ScenarioContext } from "../../contexts/ScenarioContext"

const FindingsButton = () => {
    const { displayFindings } = useContext(ScenarioContext)

    return (
        <Button
            outline
            size="sm"
            color="primary"
            onClick={displayFindings}
        >
            Patient Status
        </Button>
    )
}

export default FindingsButton
